import { Member } from '../shared/types'

const getAgeFromMember = (member: Member) => {
  let age
  if (member.birthday.year) {
    if (member.birthday.month && member.birthday.day) {
      const diffMs = Date.now() - new Date(member.birthday.year, member.birthday.month, member.birthday.day).getTime()
      const ageMs = new Date(diffMs)
      const ageYears = ageMs.getUTCFullYear() - 1970
      age = ageYears < 0 ? NaN : ageYears
    } else {
      age = new Date().getFullYear() - member.birthday.year
    }
  }
  return age
}

export default getAgeFromMember
